export default __webpack_public_path__ + "static/media/m_engineering_card10_1.131e6a5d.png";